import { geocodingService } from '@/data/services/geocoding/geocodingService'

// Browser storage that describes a user's data, as opposed to device
// preferences (theme, units), which survive a sign-out.
const USER_STORAGE_PREFIXES = ['nav-state-']

/**
 * Drop everything the previous user left behind so the next sign-in on this
 * browser starts clean: React Query cache, geocoded site locations, and the
 * persisted sidebar state.
 */
export function clearLocalSession(queryClient) {
  queryClient.clear()
  geocodingService.clearCache()
  try {
    for (const key of Object.keys(localStorage)) {
      if (USER_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key)
      }
    }
  } catch {
    // Storage unavailable; nothing to clear
  }
}
